<template>
  <CosFullLayout>

    <template #aside>
      <RuleManage :listData="listData" @selectTag="selectTag"></RuleManage>
    </template>
    <template #main>
      <SaleCue :data="selectTagName"></SaleCue>
    </template>
  </CosFullLayout>

</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import RuleManage from './components/RuleManage.vue'
import SaleCue from './components/SaleCue.vue'
import type { IndexEchart } from '@/types/index'
import CosFullLayout from '@/components/CosFullLayout/index.vue'

export default defineComponent({
  components: { RuleManage, SaleCue, CosFullLayout },
  name: 'DcCosFbuFollowRuleSetting',
  setup() {
    const listData = [
      {
        title: '销售线索',
        target: 'saleCue'
      },
      {
        title: '潜在客户',
        target: 'potentialCustomer'
      },
      {
        title: '签约客户',
        target: 'signCustomer'
      },
      {
        title: '成交客户',
        target: 'successCustomer'
      },
      {
        title: '移动端-拜访签到设置',
        target: 'appSignSetting'
      },
      {
        title: '排休日设置',
        target: 'dayOffSetting'
      }
    ]
    const selectTagName = ref<IndexEchart.RuleManageList>()
    const selectTag = (tagName: IndexEchart.RuleManageList) => {
      console.log('tagName: ', tagName)
      selectTagName.value = tagName
    }
    return { listData, selectTag, selectTagName }
  }
})
</script>
<style lang="scss" scoped></style>
